<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos del tipo de Galería</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveType" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="name" class="form__label form__label--required">Nombre del tipo de Galería (Uso interno)</label>
                <input type="text" class="form__input" name="name" id="name" placeholder="Nombre del tipo de galería" v-model="type.name" v-validate="validation.name">
                <span v-show="errors.has('name')" class="form__alert">{{ errors.first('name') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="last_name" class="form__label">Descripción del tipo de la galería</label>
                <textarea class="form__input" name="description" id="description" placeholder="Descripción del tipo de la galería" v-model="type.description" v-validate="validation.description"></textarea>
                <span v-show="errors.has('description')" class="form__alert">{{ errors.first('description') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryTypeList', params: {page: 1}}">Tipos de Galerías</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryList', params: {page: 1}}">Lista de Galerías</router-link>
        <router-link v-if="$route.name === 'galleryTypeEdit'" class="btn btn--small btn__default" :to="{name: 'galleryTypeNew'}">Nuevo Tipo</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, TypeFields, statusList, texts} from './type.mocks'
export default {
  mixins: [httpService],
  data: function () {
    return {
      validation: validation,
      type: null
    }
  },
  created: function () {
    this.start()
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      if (this.typeId) {
        this.getType()
      }
      if (!this.typeId) {
        this.type = new TypeFields()
      }
    },
    getType: function () {
      let httpRequest = {
        params: '',
        module: 'gallery_types'
      }
      this.getById(this.typeId, httpRequest)
        .then(
          type => {
            this.type = type.data
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'galleryTypeNew'})
          }
        )
    },
    saveType: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'gallery_types',
                element: this.type
              }
              let request
              if (this.$route.name === 'galleryTypeEdit') {
                request = this.put(this.typeId, httpRequest)
              } else if (this.$route.name === 'galleryTypeNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'galleryTypeNew') {
                    this.$router.push({name: 'galleryTypeEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    }
  },
  computed: {
    typeId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.type
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/galleries/type.edit.vue